var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-Twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-Twitter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,21.7816783 C3.81427746,22.895961 5.96942396,23.5454545 8.28511899,23.5454545 C15.8973337,23.5454545 20.1981361,17.3911623 19.9387277,11.8712239 C20.7398886,11.3186245 21.4350716,10.6274967 21.9847328,9.8394748 C21.2492149,10.1521098 20.4591264,10.3633088 19.6302847,10.457175 C20.4765257,9.97270425 21.1266286,9.20360697 21.432699,8.28614052 C20.6402378,8.73578992 19.7623616,9.06280766 18.8291238,9.23918529 C18.0809519,8.47614389 17.0156372,8 15.8356451,8 C13.1901533,8 11.2445899,10.3640658 11.8424948,12.8189698 C8.43459521,12.6554609 5.41343571,11.0930428 3.39194783,8.71837925 C2.31714266,10.4821555 2.83437782,12.7902043 4.66051847,13.958233 C3.98827094,13.9377944 3.3547765,13.7606598 2.80274264,13.4669494 C2.75845339,15.2852286 4.11955693,16.9854181 6.0912194,17.3646678 C5.5138774,17.5153079 4.88196472,17.5493723 4.24056148,17.4312825 C4.76096016,18.9914297 6.27549431,20.125394 8.06999978,20.1571874 C6.34667346,21.4508756 4.17491849,22.0284556 2,21.7816783",
    id: "Fill-92",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.4c011356.svg";
export { ForwardRef as ReactComponent };